import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ConcursoArquivo } from '../models/concurso-arquivo';
import { ArquivoInscricao} from '../models/arquivoInscricao';
import { FormDataService } from './api/form-data.service';

@Injectable()
export class PublicacaoService {

  constructor(private httpClient: HttpClient, private formDataService: FormDataService) { }

  PostUploadFile(concursoArquivoDTO: ConcursoArquivo, arquivos: File[]): Observable<boolean> {
    const formData = this.formDataService.createFormData<ConcursoArquivo>(concursoArquivoDTO, 'concursoArquivoDTO', arquivos);
    const formDataHeaders = this.formDataService.getFormDataHeaders();

    return this.httpClient.post<boolean>(`Interop/PostUploadFile`, formData, {
      headers: formDataHeaders,
    });
  }

  PostUploadFileCandidatoInscrito(concursoArquivoDTO: ArquivoInscricao, arquivos: File[]): Observable<boolean> {
    const formData = this.formDataService.createFormData<ArquivoInscricao>(concursoArquivoDTO, 'arquivoCandidato', arquivos);
    const formDataHeaders = this.formDataService.getFormDataHeaders();

    return this.httpClient.post<boolean>(`Interop/PostUploadFileCandidatoInscrito`, formData, {
      headers: formDataHeaders,
    });
  }

  PostConcursoArquivo(concursoArquivo: ConcursoArquivo): Observable<boolean> {
    return this.httpClient.post<boolean>(`/Interop/PostConcursoArquivo/`, concursoArquivo);
  }

  DeleteArquivo(nome: string): Observable<void> {
    return this.httpClient.delete<void>(`/Interop/DeleteArquivo/${nome}`);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/publicacao.service.ts